import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Loader2, Users, Zap, Trophy, Award } from "lucide-react";

export default function Analytics({ slug }) {
  const [stats, setStats] = useState(null);
  const [zoneA, setZoneA] = useState([]);
  const [gmA, setGmA] = useState([]);
  const [activity, setActivity] = useState([]);

  useEffect(() => {
    api.get(`/events/${slug}/analytics`).then((r) => setStats(r.data));
    api.get(`/events/${slug}/zone-analytics`).then((r) => setZoneA(r.data));
    api.get(`/events/${slug}/gm-analytics`).then((r) => setGmA(r.data));
    api.get(`/events/${slug}/activity`).then((r) => setActivity(r.data));
  }, [slug]);

  if (!stats) return <Loader2 className="w-6 h-6 animate-spin text-primary" />;
  return (
    <div className="space-y-8">
      <h1 className="font-head font-black text-2xl">Analytics</h1>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
        {[["Registered", stats.total_players], ["Active", stats.active_players], ["Zones", stats.zone_count],
          ["Completed", stats.completed_challenges], ["Total Cash", stats.total_xp], ["Finished all", stats.completed_all]].map(([l, v], i) => (
          <div key={i} className="brut p-4"><div className="font-mono-num font-extrabold text-2xl">{v}</div><div className="text-xs text-muted-foreground uppercase">{l}</div></div>
        ))}
      </div>

      <div>
        <h2 className="font-head font-bold text-lg mb-3">Challenge Zone performance</h2>
        <div className="brut overflow-x-auto">
          <table className="w-full text-sm min-w-[560px]">
            <thead className="bg-secondary"><tr>{["Rank", "Zone", "Visited", "Completed", "Avg score", "Cash", "Completion"].map((h) => <th key={h} className="text-left p-3">{h}</th>)}</tr></thead>
            <tbody>
              {zoneA.map((z) => (
                <tr key={z.zone_id} className="border-t border-border">
                  <td className="p-3 font-mono-num">#{z.popularity_rank}</td><td className="p-3 font-semibold">{z.name}</td>
                  <td className="p-3 font-mono-num">{z.players_visited}</td><td className="p-3 font-mono-num">{z.games_completed}</td>
                  <td className="p-3 font-mono-num">{z.avg_score}</td><td className="p-3 font-mono-num text-gold">{z.xp_awarded}</td>
                  <td className="p-3 font-mono-num">{z.completion_pct}%</td>
                </tr>
              ))}
              {zoneA.length === 0 && <tr><td colSpan={7} className="p-6 text-center text-muted-foreground">No data yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>

      {gmA.length > 0 && (
        <div>
          <h2 className="font-head font-bold text-lg mb-3">Game Master activity</h2>
          <div className="grid md:grid-cols-3 gap-3">
            {gmA.map((g) => (
              <div key={g.gm_id} className="brut p-4"><p className="font-bold">{g.name}</p><p className="text-xs text-muted-foreground font-mono-num mt-1">{g.players_handled} players · {g.xp_awarded} Cash · {g.games_completed} actions</p></div>
            ))}
          </div>
        </div>
      )}

      <div>
        <h2 className="font-head font-bold text-lg mb-3">Live activity feed</h2>
        <div className="space-y-2">
          {activity.map((a) => (
            <div key={a.activity_id} className="brut p-3 flex items-center justify-between text-sm">
              <span>🎉 <span className="font-semibold">{a.player_name}</span> · {a.zone_name}</span>
              <span className="font-mono-num text-neon-green font-bold">+{a.xp} Cash</span>
            </div>
          ))}
          {activity.length === 0 && <p className="text-sm text-muted-foreground">No activity yet.</p>}
        </div>
      </div>
    </div>
  );
}
